'use client';

import { useState } from 'react';

import { downloadFileFromBlob } from '@eliadmin/core/src/api/general/general-api';
import { CHECKOUT_COPY } from '@eliadmin/core/src/components/dlz/checkout/checkout-copy';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';

type OrderDocument = { id: number; name: string; number: string };

/**
 * „Stiahnuť potvrdenie PDF“: the order's first document. Documents download for a signed-in customer
 * only (core `downloadFileFromBlob` needs the token), so a guest – or an order without a document yet –
 * gets no button.
 */
export function OrderDocumentButton({ documents }: { documents: OrderDocument[] }) {
  const authToken = useCustomerStore(s => s.me?.authToken);
  const locale = useLocaleStore(s => s.currentLocale);
  const [loading, setLoading] = useState(false);
  const document = documents[0];
  if (!document || !authToken) return null;

  const download = async () => {
    setLoading(true);
    try {
      await downloadFileFromBlob({
        fileId: document.id,
        authToken,
        locale,
        fileName: `${document.name}_${document.number}`,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant="secondary"
      onClick={download}
      isLoading={loading}
      className="h-12 w-full md:h-[52px] md:w-auto"
    >
      {CHECKOUT_COPY.confirmation.download}
    </Button>
  );
}
